import type { Category } from "@/types/directory";

export const categories: Category[] = [
  {
    id: "cat-16",
    slug: "agriculture-fishing",
    name: "Agriculture & Fishing",
    description: "Farms, agri-input dealers, mechanised fishing boats, seafood suppliers and coconut trade.",
    icon: "ri-plant-line",
    image:
      "https://readdy.ai/api/search-image?query=Coastal%20Indian%20farmland%20beside%20a%20fishing%20harbour%20with%20coconut%20and%20areca%20palms%2C%20wooden%20fishing%20boats%20at%20the%20jetty%20and%20golden%20morning%20light%2C%20warm%20clean%20documentary%20photography%20with%20calm%20natural%20background&width=800&height=600&seq=cbc-cat-agri-01&orientation=landscape",
    businessCount: 132,
    subcategories: [
      { slug: "agri-inputs", name: "Agri Input Dealers" },
      { slug: "fishing-boats", name: "Fishing & Boats" },
      { slug: "seafood-suppliers", name: "Seafood Suppliers" },
      { slug: "coconut-areca", name: "Coconut & Areca Traders" },
    ],
  },
  {
    id: "cat-06",
    slug: "automobile",
    name: "Automobile & Service",
    description: "Car showrooms, two-wheeler dealers, service centres, spares and detailing studios.",
    icon: "ri-car-line",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20multi%20brand%20car%20showroom%20interior%20with%20polished%20floors%2C%20bright%20showroom%20lighting%20and%20neatly%20arranged%20vehicles%2C%20professional%20automotive%20retail%20photography&width=800&height=600&seq=cbc-cat-automobile-01&orientation=landscape",
    businessCount: 176,
    subcategories: [
      { slug: "car-dealers", name: "Car Dealers" },
      { slug: "bike-dealers", name: "Two-Wheeler Dealers" },
      { slug: "service-centres", name: "Service Centres" },
    ],
  },
  {
    id: "cat-11",
    slug: "finance",
    name: "Banking & Finance",
    description: "Banks, NBFC branches, insurance advisors, loan consultants and chit fund services.",
    icon: "ri-bank-line",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20bank%20branch%20interior%20with%20clean%20counters%2C%20bright%20professional%20lighting%20and%20organized%20service%20desks%2C%20corporate%20finance%20interior%20photography&width=800&height=600&seq=cbc-cat-finance-01&orientation=landscape",
    businessCount: 96,
    subcategories: [
      { slug: "banks", name: "Bank Branches" },
      { slug: "insurance", name: "Insurance Advisors" },
      { slug: "loans", name: "Loan Consultants" },
    ],
  },
  {
    id: "cat-09",
    slug: "beauty-spa",
    name: "Beauty & Spa",
    description: "Salons, unisex spas, bridal studios, ayurvedic massage centres and wellness therapists.",
    icon: "ri-sparkling-2-line",
    image:
      "https://readdy.ai/api/search-image?query=Serene%20modern%20spa%20and%20beauty%20salon%20interior%20with%20soft%20lighting%2C%20natural%20materials%20and%20calming%20neutral%20tones%2C%20wellness%20interior%20photography&width=800&height=600&seq=cbc-cat-beautyspa-01&orientation=landscape",
    businessCount: 231,
    subcategories: [
      { slug: "salons", name: "Hair & Beauty Salons" },
      { slug: "spa", name: "Spas & Massage" },
      { slug: "bridal", name: "Bridal Makeup" },
    ],
  },
  {
    id: "cat-17",
    slug: "electronics-mobiles",
    name: "Electronics & Mobiles",
    description: "Mobile phone stores, laptop and computer dealers, smart gadgets, accessories and repair centres.",
    icon: "ri-smartphone-line",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20mobile%20phone%20and%20laptop%20retail%20store%20interior%20with%20neatly%20arranged%20smartphones%2C%20tablets%20and%20computers%20on%20bright%20display%20counters%2C%20technology%20retail%20photography&width=800&height=600&seq=cbc-cat-electronics-mobiles-01&orientation=landscape",
    businessCount: 124,
    subcategories: [
      { slug: "mobile-stores", name: "Mobile Phone Stores" },
      { slug: "computers", name: "Laptop & Computer Dealers" },
      { slug: "gadgets", name: "Smart Gadgets & Accessories" },
      { slug: "mobile-repairs", name: "Mobile & Laptop Repairs" },
    ],
  },
  {
    id: "cat-12",
    slug: "electronics",
    name: "Home Appliances",
    description: "Television and appliance showrooms, refrigerators, washing machines, air conditioners and kitchen appliances with installation support.",
    icon: "ri-fridge-line",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20home%20appliance%20showroom%20interior%20with%20neatly%20arranged%20refrigerators%2C%20washing%20machines%20and%20large%20televisions%20under%20bright%20display%20lighting%2C%20home%20electronics%20retail%20photography&width=800&height=600&seq=cbc-cat-homeappliances-01&orientation=landscape",
    businessCount: 158,
    subcategories: [
      { slug: "tvs-audio", name: "TV & Audio" },
      { slug: "large-appliances", name: "Refrigerators & Washing Machines" },
      { slug: "air-conditioners", name: "Air Conditioners" },
      { slug: "kitchen-appliances", name: "Kitchen Appliances" },
    ],
  },
  {
    id: "cat-08",
    slug: "home-services",
    name: "Home Services",
    description: "Plumbers, electricians, painters, carpenters, packers, pest control and cleaning services.",
    icon: "ri-tools-line",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20home%20service%20technician%20with%20organized%20tool%20kit%20in%20a%20bright%20modern%20home%20interior%2C%20clean%20and%20trustworthy%20service%20photography&width=800&height=600&seq=cbc-cat-homeservices-01&orientation=landscape",
    businessCount: 143,
    subcategories: [
      { slug: "electrical", name: "Electrical" },
      { slug: "plumbing", name: "Plumbing" },
      { slug: "painting", name: "Painting & Carpentry" },
      { slug: "cleaning", name: "Cleaning & Pest Control" },
    ],
  },
  {
    id: "cat-03",
    slug: "healthcare",
    name: "Hospitals & Clinics",
    description: "Multispeciality hospitals, diagnostic labs, dental clinics, ayurveda and pharmacy services.",
    icon: "ri-heart-pulse-line",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20clean%20hospital%20reception%20with%20calming%20neutral%20interior%2C%20indoor%20plants%20and%20soft%20natural%20light%2C%20professional%20healthcare%20interior%20photography&width=800&height=600&seq=cbc-cat-healthcare-01&orientation=landscape",
    businessCount: 264,
    subcategories: [
      { slug: "multispeciality", name: "Multispeciality Hospitals" },
      { slug: "dental", name: "Dental Clinics" },
      { slug: "diagnostics", name: "Diagnostic Labs" },
      { slug: "ayurveda", name: "Ayurveda & Wellness" },
    ],
  },
  {
    id: "cat-02",
    slug: "hotels",
    name: "Hotels & Resorts",
    description: "Beach resorts, business hotels, homestays and budget stays along the Arabian Sea coast.",
    icon: "ri-hotel-bed-line",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20coastal%20luxury%20hotel%20exterior%20with%20palm%20lined%20driveway%2C%20warm%20evening%20lighting%2C%20contemporary%20Indian%20architecture%2C%20welcoming%20entrance%2C%20hospitality%20photography&width=800&height=600&seq=cbc-cat-hotels-01&orientation=landscape",
    businessCount: 186,
    subcategories: [
      { slug: "beach-resorts", name: "Beach Resorts" },
      { slug: "business-hotels", name: "Business Hotels" },
      { slug: "homestays", name: "Homestays" },
      { slug: "budget-stays", name: "Budget Stays" },
    ],
  },
  {
    id: "cat-19",
    slug: "information-technology",
    name: "Information Technology",
    description: "Software companies, IT solutions and support, web development, digital marketing and computer training institutes.",
    icon: "ri-code-s-slash-line",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20modern%20software%20office%20workspace%20with%20developers%20at%20dual%20monitors%20and%20clean%20minimal%20interior%2C%20professional%20information%20technology%20workplace%20photography&width=800&height=600&seq=cbc-cat-it-01&orientation=landscape",
    businessCount: 88,
    subcategories: [
      { slug: "software-development", name: "Software Development" },
      { slug: "it-solutions", name: "IT Solutions & Support" },
      { slug: "digital-marketing", name: "Digital Marketing" },
      { slug: "computer-training", name: "Computer Training" },
    ],
  },
  {
    id: "cat-15",
    slug: "legal-services",
    name: "Legal Services",
    description: "Advocates and lawyers, notary and documentation services, property and cyber law advisors.",
    icon: "ri-scales-3-line",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20professional%20law%20office%20interior%20with%20polished%20dark%20wood%20desk%2C%20neatly%20stacked%20legal%20documents%2C%20brass%20scale%20of%20justice%20and%20soft%20warm%20natural%20light%20through%20large%20windows%2C%20clean%20minimalist%20corporate%20photography%20with%20neutral%20background&width=800&height=600&seq=cbc-cat-legal-01&orientation=landscape",
    businessCount: 74,
    subcategories: [
      { slug: "advocates", name: "Advocates & Lawyers" },
      { slug: "notary", name: "Notary & Documentation" },
      { slug: "property-law", name: "Property & Civil Law" },
      { slug: "cyber-law", name: "Cyber Law Advisors" },
    ],
  },
  {
    id: "cat-18",
    slug: "media-entertainment",
    name: "Media & Entertainment",
    description: "News and radio stations, film production houses, event management crews, cinemas and entertainment venues.",
    icon: "ri-film-line",
    image:
      "https://readdy.ai/api/search-image?query=Cinema%20and%20media%20production%20studio%20with%20professional%20camera%20rig%2C%20warm%20stage%20lighting%20and%20sound%20equipment%2C%20clean%20creative%20studio%20photography&width=800&height=600&seq=cbc-cat-media-01&orientation=landscape",
    businessCount: 62,
    subcategories: [
      { slug: "tv-radio", name: "TV & Radio Stations" },
      { slug: "film-production", name: "Film & Production Houses" },
      { slug: "event-management", name: "Event Management" },
      { slug: "entertainment-venues", name: "Cinemas & Venues" },
    ],
  },
  {
    id: "cat-20",
    slug: "printing-publishing",
    name: "Printing & Publishing",
    description: "Offset and digital printers, screen printing, packaging units and publishing houses.",
    icon: "ri-printer-line",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20printing%20press%20workshop%20with%20offset%20printing%20machine%2C%20neatly%20stacked%20paper%20and%20colour%20proofs%20under%20bright%20industrial%20lighting%2C%20clean%20print%20production%20photography&width=800&height=600&seq=cbc-cat-printing-01&orientation=landscape",
    businessCount: 57,
    subcategories: [
      { slug: "offset-digital-printing", name: "Offset & Digital Printing" },
      { slug: "screen-printing", name: "Screen Printing" },
      { slug: "packaging", name: "Packaging Units" },
      { slug: "publishers", name: "Publishers" },
    ],
  },
  {
    id: "cat-04",
    slug: "real-estate",
    name: "Real Estate & Builders",
    description: "Builders, property developers, land promoters, rentals and real estate consultants.",
    icon: "ri-building-2-line",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20residential%20apartment%20project%20site%20with%20sales%20office%20and%20architectural%20render%20boards%2C%20contemporary%20Indian%20housing%20development%2C%20bright%20daylight%2C%20real%20estate%20photography&width=800&height=600&seq=cbc-cat-realestate-01&orientation=landscape",
    businessCount: 152,
    subcategories: [
      { slug: "builders", name: "Builders & Developers" },
      { slug: "property-consultants", name: "Property Consultants" },
      { slug: "rentals", name: "Rentals & PG" },
    ],
  },
  {
    id: "cat-01",
    slug: "restaurants",
    name: "Restaurants & Cafes",
    description: "Authentic coastal cuisine, pure-veg thali joints, bakeries and cafes across the Canara coast.",
    icon: "ri-restaurant-2-line",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20modern%20South%20Indian%20restaurant%20interior%20with%20wooden%20tables%2C%20brass%20lamps%20and%20warm%20ambient%20lighting%2C%20clean%20minimalist%20decor%2C%20welcoming%20dining%20photography&width=800&height=600&seq=cbc-cat-restaurants-01&orientation=landscape",
    businessCount: 428,
    subcategories: [
      { slug: "pure-veg", name: "Pure Veg Restaurants" },
      { slug: "seafood", name: "Seafood Speciality" },
      { slug: "cafes-bakeries", name: "Cafes & Bakeries" },
      { slug: "fine-dining", name: "Fine Dining" },
    ],
  },
  {
    id: "cat-07",
    slug: "retail",
    name: "Retail & Shopping",
    description: "Fashion stores, jewellery, footwear, textiles, gift shops and family department stores.",
    icon: "ri-shopping-bag-3-line",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20contemporary%20clothing%20boutique%20interior%20with%20neatly%20displayed%20apparel%20racks%2C%20warm%20accent%20lighting%20and%20welcoming%20retail%20atmosphere%2C%20editorial%20fashion%20store%20photography&width=800&height=600&seq=cbc-cat-retail-01&orientation=landscape",
    businessCount: 512,
    subcategories: [
      { slug: "fashion", name: "Fashion & Apparel" },
      { slug: "jewellery", name: "Jewellery" },
      { slug: "footwear", name: "Footwear" },
      { slug: "gifts", name: "Gifts & Stationery" },
    ],
  },
  {
    id: "cat-05",
    slug: "education",
    name: "Schools & Coaching",
    description: "Schools, PU colleges, coaching academies, tuition centres and skill training institutes.",
    icon: "ri-graduation-cap-line",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20modern%20classroom%20with%20rows%20of%20desks%2C%20whiteboard%20and%20large%20windows%2C%20clean%20educational%20interior%20photography%2C%20studious%20atmosphere&width=800&height=600&seq=cbc-cat-education-01&orientation=landscape",
    businessCount: 198,
    subcategories: [
      { slug: "schools", name: "Schools" },
      { slug: "pu-colleges", name: "PU & Degree Colleges" },
      { slug: "coaching", name: "Coaching Academies" },
    ],
  },
  {
    id: "cat-14",
    slug: "supermarkets",
    name: "Supermarkets & Grocery",
    description: "Supermarkets, fresh vegetable markets, provision stores and daily needs shops.",
    icon: "ri-store-2-line",
    image:
      "https://readdy.ai/api/search-image?query=Well%20stocked%20local%20supermarket%20with%20fresh%20vegetables%20and%20organized%20shelves%2C%20bright%20clean%20lighting%2C%20welcoming%20grocery%20retail%20photography&width=800&height=600&seq=cbc-cat-supermarkets-01&orientation=landscape",
    businessCount: 342,
    subcategories: [
      { slug: "supermarkets", name: "Supermarkets" },
      { slug: "vegetables", name: "Fresh Vegetables" },
      { slug: "provisions", name: "Provision Stores" },
    ],
  },
  {
    id: "cat-10",
    slug: "travel",
    name: "Travel & Tourism",
    description: "Tour operators, taxi services, temple tour packages, homestay bookings and beach getaways.",
    icon: "ri-plane-line",
    image:
      "https://readdy.ai/api/search-image?query=Scenic%20coastal%20road%20trip%20along%20the%20Arabian%20Sea%20with%20palm%20trees%20and%20warm%20golden%20light%2C%20inviting%20travel%20tourism%20photography&width=800&height=600&seq=cbc-cat-travel-01&orientation=landscape",
    businessCount: 118,
    subcategories: [
      { slug: "tour-operators", name: "Tour Operators" },
      { slug: "taxi", name: "Taxi & Cab Services" },
      { slug: "packages", name: "Holiday Packages" },
    ],
  },
  {
    id: "cat-13",
    slug: "weddings",
    name: "Weddings & Events",
    description: "Convention halls, decorators, caterers, photographers and complete wedding planners.",
    icon: "ri-heart-3-line",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20Indian%20wedding%20venue%20decorated%20with%20warm%20fairy%20lights%2C%20floral%20arrangements%20and%20draped%20fabrics%2C%20celebration%20event%20photography&width=800&height=600&seq=cbc-cat-weddings-01&orientation=landscape",
    businessCount: 87,
    subcategories: [
      { slug: "convention-halls", name: "Convention Halls" },
      { slug: "caterers", name: "Caterers" },
      { slug: "photographers", name: "Photographers" },
      { slug: "decorators", name: "Decorators" },
    ],
  },
];